<div fxLayout="column">

  <button mat-icon-button
          mat-dialog-close
          class="close-dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h2 mat-dialog-title>
    Clear All Alerts
  </h2>

  <div class="mat-dialog-title-content">
    <p> All alerts will be cleared from the form and form will be moved to the Submit tab.</p>

    <p>Would you like to clear all alerts for this form?</p>

  </div>

  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>
      Cancel
    </button>
    <button mat-button
            color="primary"
            mat-dialog-close="confirm">
      Continue
    </button>
  </div>
</div>
